import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import BooleanRen from "csi/heading/Boolean";
import reflection from "csi/reflection";
import declare from "dojo/_base/declare";

const AttributesRenderer = declare(BooleanRen, {
	bBaseRenderer: true,
	bCopy: true,

	/**
	 * @override
	 * make uneditable when checked
	 */
	_getRenderAction(ctx: Context, h: Heading): ActionData {
		const subtypeNode = ctx.getNodeParent(null);
		if (subtypeNode.Published) {
			const selections = reflection.getSubtypeSetting(subtypeNode.$URL, h.m_id);
			if (selections[ctx.keyValue]) {
				return null;
			}
		}
		return this.inherited<ActionData>(arguments);
	},
});

export = AttributesRenderer;